import StarIcon from "../../assets/svgs/common/star.svg";
import { SearchSelect } from "../search-select.components";
import { FormControl, FormField, FormItem, FormLabel } from "../ui/form";
import type { FieldValues, Path, UseFormReturn } from "react-hook-form";

type FormSearchProps<T extends FieldValues, U = any> = {
  form: UseFormReturn<T>;
  name: Path<T>;
  label?: string;
  placeholder: string;
  required?: boolean;
  options: {
    value: string;
    label: string;
    data?: U; // Additional data that can be passed
  }[];
  fetcher?: (searchQuery: string) => void;
  fetching?: boolean;
  onSearch?: (searchQuery: string) => void;
  showAllOnEmpty?: boolean;
  maxResultsWhileSearching?: number;
  disabled?: boolean;
  emptyMessage?: string;
};

export const FormSearch = <T extends FieldValues, U = any>({
  form,
  name,
  label,
  placeholder,
  required,
  options,
  fetcher,
  fetching,
  onSearch,
  showAllOnEmpty = true,
  maxResultsWhileSearching = 5,
  disabled = false,
  emptyMessage = "No results found",
}: FormSearchProps<T, U>) => {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel className="flex items-center gap-1 font-semibold">
            {label}
            {required && <span className="text-red-500"><StarIcon/></span>}
          </FormLabel>
          <FormControl>
            <SearchSelect
              fetcher={fetcher}
              fetching={fetching}
              onSearch={onSearch}
              className="py-3 pl-4 border border-border rounded-xl font-semibold placeholder:text-secondary"
              placeholder={placeholder}
              disabled={disabled}
              value={field.value || ""}
              options={options}
              onValueChange={(value) => {
                field.onChange(value);
              }}
              showAllOnEmpty={showAllOnEmpty}
              maxResultsWhileSearching={maxResultsWhileSearching}
              emptyMessage={emptyMessage}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};